import React from 'react';
import { Alert, Form, Icon, Input, Button } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { resetPassword, loginTwoFactor } from '../../reducers/user/actions';
import {getUserToken} from "../../reducers/user/selectors";
import { resetPasswordConfirmUserRequest } from '../../api/requests';

import classes from './ResetForm.css';
import { withNamespaces } from 'react-i18next';
import { getTheme } from '../../reducers/theme/selectors';
import logoDefault from "../../assets/img/diamind_logo.png";

const routes = require('../../routes.json');

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ResetForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: '',
    };
  }

  async componentDidMount() {
    if (this.props.token) {
      try {
        await resetPasswordConfirmUserRequest({ token: this.props.token });
      } catch (e) {
        this.setState({ checkConfirmRequestError: get(e, 'response.data.message', this.props.i18n.t('Error')) });
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });
        try {
          const response = await this.props.resetPassword({ username: get(values, 'username') });
          this.setState({
            responseMessage: get(response, 'data.message'),
          });
        } catch (e) {
          this.setState({
            errorMessage: get(e, 'response.data.msg')
          });
        }
        this.setState({ isLoading: false });
      }
    });
  };


  render() {
    const { token } = this.props;
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { isLoading, errorMessage, responseMessage, isSubmitted, checkConfirmRequestError } = this.state;

    const usernameError = (isFieldTouched('username') || isSubmitted) && getFieldError('username');

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <h2 className={classes.headline}>
            <img alt="diamond-trial-logo" src={this.props.theme.logo_dark} style={{ objectFit: 'contain', width: '160px', height: 'auto', marginBottom: '10px' }} />
            <br/>
            {this.props.i18n.t('DCTMS Trial - Password Reset')}
          </h2>

          {!token && !responseMessage && (<div>
            <Form.Item validateStatus={usernameError ? 'error' : ''} help={usernameError || ''}>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: 'Required' }]
              })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('Username')} />,
              )}
            </Form.Item>
          </div>)}

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Form.Item>
            <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
              {this.props.i18n.t('Reset password')}
              {isLoading && <Icon type="loading" />}
            </Button>
          </Form.Item>)}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userToken: getUserToken(state),
  theme: getTheme(state)
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
};

export default Form.create({ name: 'login' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ResetForm)));



// WEBPACK FOOTER //
// ./src/components/ResetForm/ResetForm.js